import React from 'react';

import { Row,Col, Divider, Switch, Modal, message, Alert, Input } from 'antd';

import {verifIsLogged, getMachineId, getBaseURL, getLanguage} from "../../util/Toolbox";

import './../css/historique.css';

import axios from '../../util/Api'

class MagasinFiche extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      ...props.magasin,
      language : getLanguage()
    }
  }


  async componentDidMount() {

    verifIsLogged();

    let guid_compte = getMachineId();

    let baseURL = getBaseURL();
    this.setState({baseURL});

    this.state.guid_compte = guid_compte;

    console.log(this.state);
       
}


  handleOk = () => {
      console.log('handleOk');

      if(this.state.NomMagasin == '' || this.state.NomMagasin == null){
        message.warning("Le nom du magasin est obligatoire");
        return;
      }

      this.props.onSave(this.state);
  }

  handleChangeValue = (dataType, value) => {

    this.setState({[dataType]: value});
  }


  onIsSommeil = (IsSommeil) => {
    this.setState({IsSommeil});
  }


  render() {

    
      return (

        <Modal
          title={this.state.AdresseMagasin ? "Modification du magasin " + this.state.AdresseMagasin : "Ajouter un magasin"}
          onOk={() => this.handleOk() }
          onCancel={this.props.onClose}
          open={this.props.openState}
          closable={false}
          maskClosable={false}
          width={600}
      >

          <div>

            <div style = {{marginTop : -5}}  className="gx-modal-box-row">
               
            <Divider orientation="left">Informations du magasin</Divider>
           
              <Row style={{marginTop : -10}}>
                  <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                    Nom du magasin
                    <Input
                      required
                      placeholder="Nom du magasin"
                      onChange={(event) => this.handleChangeValue('NomMagasin', event.target.value)}
                      defaultValue={this.state.NomMagasin}
                      margin="none"
                      autoFocus
                    />
                  </Col>
              </Row>

              <Row>
                    <Col xl={24} lg={24} md={24} sm={12} xs={18}>
                      Adresse
                      <Input
                        required
                        placeholder="Adresse du magasin"
                        onChange={(event) => this.handleChangeValue('AdresseMagasin', event.target.value)}
                        defaultValue={this.state.AdresseMagasin}
                        margin="none"
                      />
                    </Col>
              </Row>

              <Row gutter={10}>
                  <Col xl={7} lg={7} md={7} sm={12} xs={18}>
                    Code postal
                    <Input
                      required
                      placeholder="Code postal du magasin"
                      onChange={(event) => this.handleChangeValue('CodePostalMagasin', event.target.value)}
                      defaultValue={this.state.CodePostalMagasin}
                      margin="none"
                    />
                  </Col>

                  <Col xl={17} lg={17} md={12} sm={12} xs={18}>
                    Ville
                    <Input
                      required
                      placeholder="Ville du magasin"
                      onChange={(event) => this.handleChangeValue('VilleMagasin', event.target.value)}
                      defaultValue={this.state.VilleMagasin}
                      margin="none"
                    />
                  </Col>
                
              </Row>

              <Row gutter={10}>
                  <Col xl={12} lg={12} md={12} sm={12} xs={18}>
                    Email 
                    <Input
                      required
                      placeholder="Adresse email du magasin"
                      onChange={(event) => this.handleChangeValue('EmailMagasin', event.target.value)}
                      defaultValue={this.state.EmailMagasin}
                      margin="none"
                    />
                  </Col>

                  <Col xl={6} lg={6} md={6} sm={12} xs={18}>
                    Téléphone
                    <Input
                      required
                      placeholder="Téléphone du magasin"
                      onChange={(event) => this.handleChangeValue('NumeroTelephoneMagasin', event.target.value)}
                      defaultValue={this.state.NumeroTelephoneMagasin}
                      margin="none"
                    />
                  </Col>

                  <Col xl={6} lg={6} md={6} sm={12} xs={18}>
                    Magasin désactivé
                    <Switch checked={Boolean(this.state.IsSommeil)} onChange={this.onIsSommeil} />
                  </Col>

              </Row>

            <Alert style = {{marginTop : 10}} message="Ces informations seront présentes sur le PDF d'analyse du client" type="info" showIcon />

            <Divider orientation="left">Informations de connexion du magasin</Divider>

            <Row  gutter={10} style = {{marginTop : -10}}>
                  <Col xl={12} lg={12} md={12} sm={12} xs={18}>
                    Identifiant 
                    <Input
                      required
                      
                      onChange={(event) => this.handleChangeValue('Login', event.target.value)}
                      defaultValue={this.state.Login}
                      disabled = {true}
                    />
                  </Col>

                  <Col xl={12} lg={12} md={12} sm={12} xs={18}>
                    Mot de passe
                    <Input
                      required
                      onChange={(event) => this.handleChangeValue('Password', event.target.value)}
                      defaultValue={this.state.Password}
                      disabled = {true}
                    />
                  </Col>
              </Row>

              <Alert style = {{marginTop : 10}} message="Le couple identifiant / mot de passe de ce magasin" type="info" showIcon />

            </div>

          </div>
    
      </Modal>

      )

    };
}


export default MagasinFiche;
